import { useEditor, Frame } from '@craftjs/core';
import { useEffect } from 'react';
import slugify from 'slugify';

export interface Section {
  label: string;
  slug: string;
  id: string;
}

interface Props {
  json?: string;
  setSections: any;
}

const Canvas = ({ json, setSections }: Props) => {
  const {
    store: { query },
  } = useEditor();

  useEffect(() => {
    const sections: Section[] = [];

    if (json) {
      const nodes = query.getNodes();

      Object.values(nodes).forEach((node) => {
        if (node?.data?.name === 'SectionBlock' && node?.data?.props?.title) {
          sections.push({
            id: node.id,
            label: node.data.props.title,
            slug: slugify(node.data.props.title ?? '', { lower: true }),
          });
        }
      });
    }
    if (sections.length) setSections(sections);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="editor__canvas">
      <div className="viewport">
        <Frame data={json} />
      </div>
    </div>
  );
};

export default Canvas;
